<template>
    <div class="top-container">
        <el-scrollbar class="second-container">
            <div class="title-box">
                <div class="title-name title-active">消息中心</div>
                <div class="title-more" @click="cleanAllUnread">全部已读</div>
            </div>
            <div class="msg-container">
                <div class="msg-item" v-for="(item, index) in msgList" :key="index">
                    <el-card class="msg-one" :body-style="{ padding: '0px' }"
                             @click.stop="cleanUnread(item)">
                        <div class="msg-info-icon">
                            <div class="msg-icon">
                                <img v-if="item.code === 1" src="../../assets/image/msg-1.png" alt>
                                <img v-if="item.code === 2" src="../../assets/image/msg-2.png" alt>
                                <img v-if="item.code === 3" src="../../assets/image/msg-3.png" alt>
                                <img v-if="item.code === 4" src="../../assets/image/msg-4.png" alt>
                            </div>
                            <div class="msg-type">
                                <span v-if="item.code === 1">系统消息</span>
                                <span v-if="item.code === 2">教研消息</span>
                                <span v-if="item.code === 3">培训消息</span>
                                <span v-if="item.code === 4">活动消息</span>
                            </div>
                        </div>
                        <div class="msg-content">
                            {{ item.content }}
                        </div>
                        <div class="msg-time">
                            <div class="msg-read">
                                <div class="msg-unread" v-if="item.isRead === 0"></div>
                            </div>
                            <div class="msg-time-info">
                                {{timestampToTime(item.createTime) }}
                            </div>

                        </div>
                    </el-card>
                </div>
            </div>
        </el-scrollbar>
<!--        <div class="clear-container">-->
<!--            <img src="../../assets/image/clean_all.png" alt>-->
<!--        </div>-->
    </div>
</template>

<script>

import { userMessages, cleanUnread, messageCleanAllUnread } from "@/api/admin/message"
import {timestampToTime} from "@/utils/date";
import {ElMessageBox} from "element-plus";

export default {
    name: "systemCenter",
    components: {},
    data() {
        return {
            timestampToTime,
            token: this.$storage.get("token"),
            // 基础：基数数据表格数据
            msgList: [],
        };
    },
    created() {
        this.getMsgList();
    },
    activated() {},
    watch: {},
    methods: {
        getMsgList(){
            userMessages({code:1}).then(res => {
                res.data.data = res.data.data.filter(item => {
                    return item.code === 1
                })
                this.msgList = res.data.data;
            });
        },
        cleanUnread(item) {
            if (item.isRead === 0){
                cleanUnread({ messageId: item.messageId }).then(res => {
                    if (res.data.code === 1) {
                        this.$message.success("已阅");
                        this.getMsgList();
                    } else {
                        this.$message.error("操作失败");
                    }
                })
            }

        },
        cleanAllUnread() {
            var _this = this;
            ElMessageBox.confirm(
              '消息是否全部已读?',
              '通知',
              {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              }
            ).then(() => {
                messageCleanAllUnread().then(res => {
                    if (res.data.code === 1) {
                        _this.$message.success("操作成功");
                        _this.getMsgList();
                    } else {
                        _this.$message.error("操作失败");
                    }
                })
            }).catch(() => {

            })
        },
    }
};
</script>
<style scoped>
.top-container{
    width: 100%;
    padding:10px 5px 10px 10px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto!important;
}
.second-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    box-sizing: border-box;
}
.msg-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: auto;
    align-items: center;
}
.msg-item{
    width: 25%!important;
    display: flex;
    flex-wrap: wrap;
    height: auto;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 10px;
}
.msg-one{
    width: 100%;
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.msg-info-icon{
    display: flex;
    width: 100%;
    height: 32px;
    padding-bottom: 5px;
    border-bottom: 1px dashed #ccc;
}
.msg-icon{
    display: flex;
    width: 32px;
    height: 32px;
    img{
        width: 100%;
        height: 100%;
    }
}
.msg-type{
    //display: flex;
    width: calc(100% - 30px);
    height: 32px;
    line-height: 32px;
    text-align: right;
    font-size: 14px;
    text-indent: 20px;
    color: #333;
}
.msg-content{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 20px;
    text-indent: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}
.msg-time{
    display: flex;
    width: 100%;
    height: 30px;
}
.msg-read{
    width: 40px;
    height: 30px;
}
.msg-time-info{
    width: calc(100% - 40px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    color: grey;
}
.msg-unread{
    width:10px;
    height:10px;
    border-radius:10px;
    background: #41cfcc;
    margin-top: 10px;
    //margin-left: 10px;
}
.clear-container{
    position: fixed;
    bottom: 10px;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: #ff7f2e;
    border-radius: 25px;
    box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    img{
        width: 40px;
        height: 40px;
    }
}


.title-box{
    display: flex;
    width: 100%;
    height: 36px;
    border-bottom: 2px solid #cecece;
}
.title-name{
    width: auto;
    height: 36px;
    line-height: 38px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    //color: #fff;
    //background-color: #cecece;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    color: #333333;
}
.title-active{
    //color: #fff;
    //background: #ff7f2e!important;
}
.title-more{
    color: #666!important;
    font-size: 14px;
    height: 36px;
    line-height: 38px;
    margin-left: auto;
    padding-right: 30px;
    cursor: pointer;
}
.title-more:hover{
    color: #ff7f2e!important;
}
</style>